import { Instagram, Phone, Mail } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-sand border-t border-line"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12 py-14">
                <div className="grid md:grid-cols-3 gap-10 items-start">
                    <div>
                        <p className="font-serif text-2xl text-ink">
                            Cindy <span className="italic text-rose-700">Bien-Naître</span>
                        </p>
                        <p className="mt-3 text-sm text-ink-soft leading-relaxed max-w-xs">
                            Accompagnement à la naissance & périnatalité —
                            Montpellier et alentours.
                        </p>
                    </div>

                    <div>
                        <p className="text-xs tracking-[0.25em] uppercase text-rose-700 mb-4">
                            Contact
                        </p>
                        <ul className="space-y-2 text-sm text-ink-soft">
                            <li>
                                <a
                                    href="tel:+33661255241"
                                    className="inline-flex items-center gap-2 hover:text-rose-700 transition-colors"
                                    data-testid="footer-phone"
                                >
                                    <Phone size={14} /> 06 61 25 52 41
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:cindy.bien.naitre@gmail.com"
                                    className="inline-flex items-center gap-2 hover:text-rose-700 transition-colors break-all"
                                    data-testid="footer-email"
                                >
                                    <Mail size={14} /> cindy.bien.naitre@gmail.com
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/cindy_bien_naitre/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 hover:text-rose-700 transition-colors"
                                    data-testid="footer-instagram"
                                >
                                    <Instagram size={14} /> @cindy_bien_naitre
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:text-right">
                        <p className="text-xs tracking-[0.25em] uppercase text-rose-700 mb-4">
                            Navigation
                        </p>
                        <ul className="space-y-2 text-sm text-ink-soft">
                            <li>
                                <a href="#accueil" className="hover:text-rose-700 transition-colors">Accueil</a>
                            </li>
                            <li>
                                <a href="#a-propos" className="hover:text-rose-700 transition-colors">À propos</a>
                            </li>
                            <li>
                                <a href="#services" className="hover:text-rose-700 transition-colors">Services</a>
                            </li>
                            <li>
                                <a href="#temoignages" className="hover:text-rose-700 transition-colors">Témoignages</a>
                            </li>
                            <li>
                                <a href="#contact" className="hover:text-rose-700 transition-colors">Contact</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-line flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-ink-soft">
                    <p>© {new Date().getFullYear()} Cindy Bien-Naître. Tous droits réservés.</p>
                    <p className="italic">Avec douceur et bienveillance.</p>
                </div>
            </div>
        </footer>
    );
}
